<template>
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-auto large-card">
        <h2>List of Urbanlume Solutions</h2>
        <div class="position-relative custom-scrollbar">
          <div
            class="row small-card"
            v-for="(item, index) in listMarker"
            :key="index"
            @click="() => goToSite(item.siteId)"
          >
            <div
              class="col-auto image"
              :style="{
                backgroundColor: item.streetlights ? '#1DAEEF' : '#009a78',
              }"
            >
              <img :src="require(`@/assets/images/icon/${item.icon}.png`)" />
            </div>
            <div class="col desc">
              <h3 :style="{ color: item.streetlights ? '#1DAEEF' : '#009a78' }">
                {{ item.title }}
              </h3>
              <p v-if="item.operational">
                Operational<span>: {{ item.operational }}</span>
              </p>
              <p v-if="item.site">
                Site<span>: {{ item.site }}</span>
              </p>
              <p v-if="item.streetlights">
                Streetlights<span>: {{ item.streetlights }}</span>
              </p>
              <!-- <p v-if="item.gateway">
                Gateway<span>: {{ item.gateway }}</span>
              </p> -->
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <HomeMap :markers="listMarker" />
      </div>
    </div>
  </div>
</template>
<script>
import HomeMap from "./maps/maps/homeMap.vue";
// import siteData from "../data/api/site.json";

export default {
  components: {
    HomeMap,
  },
  mounted() {
    this.getOverviewData();
  },
  created() {
    // this.getSite();
    this.setHeaderComponent();
  },
  data() {
    return {
      useMock: false,
      listMarker: [],
      list: [
        {
          title: "Smart Façade Lighting",
          icon: "facade",
          operational: "9 / 10",
          site: "Zone 1",
          siteId: "9044e0c8-c4c6-4a66-9e2e-200c7d83c8d1",
        },
        {
          title: "Smart Façade Lighting",
          icon: "facade",
          operational: "9 / 10",
          site: "Zone 2",
          siteId: "9044e0c8-c4c6-4a66-9e2e-200c7d83c8d1",
        },
        // {
        //   title: "STL - PPj Presint 15",
        //   icon: "street",
        //   operational: null,
        //   site: null,
        //   streetlights: "295 / 300",
        //   gateway: "2 / 3",
        //   siteId: "9044e0c8-c4c6-4a66-9e2e-200c7d83c8d1",
        // },
        // {
        //   title: "Smart Façade Lighting",
        //   icon: "facade",
        //   operational: "9 / 10",
        //   site: "Zone 2",
        // },
        // {
        //   title: "Smart Street Lighting",
        //   icon: "street",
        //   operational: "295 / 300",
        //   site: "Zone 1",
        // },
        // {
        //   title: "Smart Street Lighting",
        //   icon: "street",
        //   operational: "295 / 300",
        //   site: "Zone 2",
        // },
      ],
    };
  },
  methods: {
    async getOverviewData() {
      this.listMarker = [];
      this.list = [];
      await this.$http.get(":11000/api/v1/overview").then((res) => {
        if (!res.error) {
          let response = res.message.ClusterData;

          if (response != null) {
            for (var i = 0; i < response.length; i++) {
              let obj = {
                title: response[i].ClusterName,
                icon: "street",
                operational: null,
                site: null,
                streetlights:
                  response[i].ClusterAttribute.DeviceCount +
                  " / " +
                  response[i].ClusterAttribute.TotalDevice,
                gateway: "2 / 3",
                siteId: response[i].ClusterID,
                SiteLat: response[i].Latitude,
                SiteLong: response[i].Longitude,
                latLng: [response[i].Latitude, response[i].Longitude],
                // SiteId: response[i].ClusterID,
                siteName: response[i].ClusterName,
                siteIcon: "street",
              };
              this.listMarker.push(obj);
            }
          }
        }
      });
    },
    async getSite() {
      const res =
        //  this.useMock
        //   ? siteData
        //   :
        await // this.$http.get("/api/v1/site/9044e0c8-c4c6-4a66-9e2e-200c7d83c8d1")
        fetch(
          process.env.VUE_APP_API_URL +
            "/api/v1/site/9044e0c8-c4c6-4a66-9e2e-200c7d83c8d1"
        ).then((r) => r.json());
      this.listMarker = res.message.Site.map((item) => {
        return {
          ...item,
          latLng: [item.SiteLat, item.SiteLong],
          siteId: item.SiteId,
        };
      });
    },
    goToSite(id) {
      this.$router.push("/cluster?id=" + id);
    },
    setHeaderComponent() {
      // Data last updated 5 minutes ago
      this.$store.dispatch("common/setHeaderComponent", {
        title: "URBANLUME",
        subtitle: "",
        showBack: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrapper.only-body .page-body-wrapper .page-body {
  min-height: calc(100vh - 137px);
}
h2 {
  color: #009a78;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 32px;
}
.large-card {
  width: 430px;
  height: calc(100vh - 168px);
  padding: 35px;
  border-radius: 8px 0px 0px 8px;
  background: #fff;
}
.small-card {
  border-radius: 8px;
  background: #f5f6fa;
  margin: 11px 0;
  cursor: pointer;
  .desc {
    padding: 11px 0 0 14px;
    color: #9b9a9a;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 25px;
    width: 270px;
    p {
      margin: 0;
      display: flex;
      justify-content: space-between;
      width: 100%;
      span {
        width: 100px;
      }
    }
    h3 {
      color: #009a78;
      font-family: Inter;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }
  .image {
    border-radius: 8px 0px 0px 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 91px;
    height: 91px;
    img {
      width: 100%;
      height: 100%;
      min-width: 33px;
      min-height: 38px;
      max-width: 60px;
      max-height: 46px;
      object-fit: contain;
      object-position: center;
    }
  }
}
</style>
